module.exports = __webpack_public_path__ + "img/search-2.3e34b3bb.svg";